import React from 'react';
import { Fragment } from 'react';
import { UserShape } from '../shapes';
import MobileAppChecker from '../services/utils/mobile_app_checker';
import { Link } from 'react-router-dom';
import SubscriptionOptions from './subscription/subscription_options';
import PropTypes from 'prop-types';
import Waiting from './waiting';
import verified from '../images/verified-blue.svg';

export default class AccountConfirmation extends React.Component {
  static propTypes = {
    user: UserShape,
    params: PropTypes.object,
    onConfirmUser: PropTypes.func
  }

  componentDidMount() {
    this.props.onConfirmUser(this.props.params.confirmation_token);
  }

  render() {
    if (this.props.user.get('confirmed')) {
      return this.renderConfirmed();
    } else if (this.props.user.get('error')) {
      return this.renderConfirmationError();
    } else {
      return this.renderConfirming();
    }
  }

  renderConfirmed() {
    if (MobileAppChecker.isMobileApp()) {
      if (process.env.REACT_APP_MOBILE_SUBSCRIPTION_UPGRADE_ENABLED === 'false') {
        return this.renderConfirmedNoUpgrade();
      }
    }
    return this.renderConfirmedUpgrade();
  }

  renderConfirmedUpgrade() {
    return(
      <Fragment>
        <div className='row'>
          <p className='col-sm-12'>
            Confirmed! You're on the Free for One plan, which is a good start.
            But if you're feeling bold, think about going <b>Unlimited</b> for ${process.env.REACT_APP_SUBSCRIPTION_FEE} per month.
            Oh, and we'll give you one of these <span className='verified-mark-15-inline'>
              <img src={verified} alt='Verified and Unlimited' />
            </span>.
          </p>
        </div>
        <SubscriptionOptions hasActiveSubscription={ false }/>
      </Fragment>
    )
  }

  renderConfirmedNoUpgrade() {
    return (
      <Fragment>
        <div className='row'>
          <p className='col-sm-12 center'>
            Confirmed!
          </p>
          <p className='col-sm-12 action center'>
            <Link to='/' className='btn btn-dark' data-primary-cta='true'>Thanks</Link>
          </p>
        </div>

      </Fragment>
    )
  }

  renderConfirming() {
    return(<Waiting waitingText={ 'Confirming' } />);
  }

  renderConfirmationError() {
    return(
      <div className='confirmation'>
        Hmm, we had a problem confirming your email. Try again?
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account_confirmation.jsx